export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          投稿合作
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          我们欢迎每一位热爱漫画的创作者与合作伙伴
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200 overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-background-200">
              <div className="p-6 md:p-8 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500">
                  <i className="ri-send-plane-fill text-xl"></i>
                </div>
                <h3 className="text-sm font-bold font-heading text-foreground-900 mb-2">漫画投稿</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                  原创漫画作者欢迎投稿，我们将为你提供展示平台和推广资源。
                </p>
                <span className="text-xs text-primary-500 font-medium whitespace-nowrap">comic@waiwai-manga.com</span>
              </div>

              <div className="p-6 md:p-8 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-briefcase-line text-xl"></i>
                </div>
                <h3 className="text-sm font-bold font-heading text-foreground-900 mb-2">商务合作</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                  广告投放、品牌联名、渠道合作等商务需求，我们期待与你共赢。
                </p>
                <span className="text-xs text-accent-600 font-medium whitespace-nowrap">biz@waiwai-manga.com</span>
              </div>

              <div className="p-6 md:p-8 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600">
                  <i className="ri-question-answer-fill text-xl"></i>
                </div>
                <h3 className="text-sm font-bold font-heading text-foreground-900 mb-2">意见反馈</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                  对网站有任何建议或问题？欢迎随时联系我们，每一条反馈都会认真对待。
                </p>
                <span className="text-xs text-secondary-600 font-medium whitespace-nowrap">help@waiwai-manga.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}